import type { DownloadFileProgressStatusDatagramBuf, DownloadFinishedStatusDatagramBuf, DownloadProgressStatusDatagramBuf, DownloadStartedStatusDatagramBuf } from "~/classes/generated/status"

import { parseFileId } from "~/utils/flatbuffers/id"
import { parseTransferId } from "~/utils/flatbuffers/local"

const console = useLogger("local/download")

export function handleDownloadStartedStatusDatagramBuf(buf: DownloadStartedStatusDatagramBuf) {
  const { onDownloadJobStarted } = useJobs()

  const status: DownloadStartedStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    approxTotal: buf.approxTotal(),
    approxTotalBytes: buf.approxTotalBytes(),
  }

  console.debug("Download Started", status)
  onDownloadJobStarted(status)
}

export function handleDownloadProgressStatusDatagramBuf(buf: DownloadProgressStatusDatagramBuf) {
  const { onDownloadJobProgressStatus } = useJobs()

  const status: DownloadProgressStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    approxTotal: buf.approxTotal(),
    approxTotalBytes: buf.approxTotalBytes(),
    completed: buf.completed(),
    completedBytes: buf.completedBytes(),
    failed: buf.failed(),
    failedBytes: buf.failedBytes(),
  }

  console.debug("Transfer Status", status)
  onDownloadJobProgressStatus(status)
}

export function handleDownloadFileProgressStatusDatagramBuf(buf: DownloadFileProgressStatusDatagramBuf) {
  const { onDownloadFileProgressStatus } = useJobs()

  const status: DownloadFileProgressStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    fileId: parseFileId(buf.fileId()!),
    completedBytes: buf.completedBytes(),
    totalBytes: buf.totalBytes(),
  }

  console.debug("Transfer Status", status)
  onDownloadFileProgressStatus(status)
}

export function handleDownloadFinishedStatusDatagramBuf(buf: DownloadFinishedStatusDatagramBuf) {
  const { onDownloadJobFinished } = useJobs()

  const status: DownloadFinishedStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    approxTotal: buf.approxTotal(),
    approxTotalBytes: buf.approxTotalBytes(),
    failed: buf.failed(),
    failedBytes: buf.failedBytes(),
    success: buf.success(),
  }

  console.debug("Transfer Finished", status)
  onDownloadJobFinished(status)
}
